import React, {useMemo} from 'react';

const allowed = new Set(['p', 'br', 'strong', 'b', 'em', 'i', 'ul', 'ol', 'li', 'a', 'figure', 'figcaption', 'img']);
const blocked = new Set(['script', 'style', 'iframe', 'object', 'embed', 'svg', 'math', 'template']);

function safeUrl(value) {
    try {
        const url = new URL(value);
        return ['https:', 'http:'].includes(url.protocol) ? url.href : undefined;
    } catch {
        return undefined;
    }
}

// Build React elements with an explicit allowlist; never inject stored HTML.
export function renderNotesHtml(html) {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    function render(node, key) {
        if (node.nodeType === 3) return node.textContent;
        if (node.nodeType !== 1) return null;
        const tag = node.localName;
        if (blocked.has(tag)) return null;
        const children = Array.from(node.childNodes, render);
        if (!allowed.has(tag)) return children;
        const props = {key};
        if (tag === 'figure') {
            const width = node.style.width;
            if (/^(?:100|[1-9]\d?)(?:\.\d+)?%$/.test(width) && parseFloat(width) <= 100) {
                props.style = {width};
            }
        }
        if (tag === 'img') {
            props.src = safeUrl(node.getAttribute('src'));
            if (!props.src) return null;
            props.alt = node.getAttribute('alt') || '';
            props.loading = 'lazy';
            return React.createElement(tag, props);
        }
        if (tag === 'a') props.href = safeUrl(node.getAttribute('href'));
        if (tag === 'br') return React.createElement(tag, props);
        return React.createElement(tag, props, children);
    }
    return Array.from(doc.body.childNodes, render);
}

export default function TourNotes({value, format}) {
    const content = useMemo(() => format === 'html' ? renderNotesHtml(value) : value, [value, format]);
    return <div style={{whiteSpace: format === 'html' ? 'normal' : 'pre-wrap'}}>{content}</div>;
}
